import { useState } from 'react';
import SessionPackages from '../components/SessionPackages';
import { languagePricing, mathPricing, romanianPricing } from '../data/packagesData';

type TabType = 'languages' | 'romanian' | 'math';
type SessionType = 'group' | 'individual';

const tabLabels: Record<TabType, string> = {
  languages: 'Limbi străine',
  romanian: 'Limba română',
  math: 'Matematică'
};

const Packages = () => {
  const [activeTab, setActiveTab] = useState<TabType>('languages');
  const [activeSessionType, setActiveSessionType] = useState<SessionType>('group');

  const courses = activeTab === 'languages'
    ? languagePricing[activeSessionType]
    : activeTab === 'romanian'
      ? romanianPricing
      : mathPricing;

  return (
    <div className="page-surface py-20 sm:py-24">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="mb-12 max-w-3xl">
          <p className="eyebrow">Cursuri și prețuri</p>
          <h1 className="page-heading mt-5 font-bold">Alege formatul care i se potrivește.</h1>
          <p className="mt-5 max-w-2xl text-xl text-gray-600">
            Prețuri clare, pe ședință sau pachet, în funcție de materie, clasă și format.
          </p>
        </div>

        <div className="mb-8 flex justify-center">
          <div className="flex flex-wrap justify-center gap-2 rounded-full border border-blue-100 bg-white p-2 shadow-float">
            {(Object.keys(tabLabels) as TabType[]).map((tab) => (
              <button
                type="button"
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`rounded-full px-6 py-3 font-semibold transition-colors duration-200 ${
                  activeTab === tab ? 'bg-blue-600 text-white' : 'text-gray-600 hover:bg-gray-100'
                }`}
              >
                {tabLabels[tab]}
              </button>
            ))}
          </div>
        </div>

        {activeTab === 'languages' ? (
          <div className="mb-8 flex justify-center">
            <div className="inline-flex rounded-full border border-blue-100 bg-white p-2 shadow-float">
              <button
                type="button"
                onClick={() => setActiveSessionType('group')}
                className={`rounded-full px-6 py-3 font-semibold transition-colors duration-200 ${
                  activeSessionType === 'group' ? 'bg-blue-600 text-white' : 'text-gray-600 hover:bg-gray-100'
                }`}
              >
                Ședințe în grupă
              </button>
              <button
                type="button"
                onClick={() => setActiveSessionType('individual')}
                className={`rounded-full px-6 py-3 font-semibold transition-colors duration-200 ${
                  activeSessionType === 'individual' ? 'bg-blue-600 text-white' : 'text-gray-600 hover:bg-gray-100'
                }`}
              >
                Ședințe individuale
              </button>
            </div>
          </div>
        ) : (
          <p className="mb-8 text-center font-medium text-gray-600">
            Ședințele de {activeTab === 'romanian' ? 'limba română' : 'matematică'} se desfășoară doar în grupă și au durata de 2 ore.
          </p>
        )}

        <SessionPackages courses={courses} />
      </div>
    </div>
  );
};

export default Packages;
